export const TIPOS_TELEFONO = [
  { id: '', descripcion: 'Seleccionar' },
  { id: 'celular', descripcion: 'Celular' },
  { id: 'fijo', descripcion: 'Fijo' },
]

export const VALIDATION_MESSAGES = {
  MIN_LENGTH_ERROR: 'Ingresá al menos dos caracteres',
}

export const FORM_LABELS = {
  APELLIDO: 'Apellido',
  NOMBRE: 'Nombre',
  CORREO_ELECTRONICO: 'Correo electrónico',
  TIPO_TELEFONO_PRINCIPAL: 'Tipo de teléfono principal',
  NUMERO_TELEFONO_PRINCIPAL: 'Número de teléfono principal',
  TIPO_TELEFONO_ALTERNATIVO: 'Tipo de teléfono alternativo',
  NUMERO_TELEFONO_ALTERNATIVO: 'Número de teléfono alternativo',
}

export const FORM_PLACEHOLDERS = {
  APELLIDO: 'Ingresá tu apellido',
  NOMBRE: 'Ingresá tu nombre',
  CORREO_ELECTRONICO: 'ejemplo@correo.com',
  NUMERO_TELEFONO_PRINCIPAL: 'Ingresá tu número',
  NUMERO_TELEFONO_ALTERNATIVO: 'Ej: 1122233344',
  SELECCIONAR: 'Seleccionar',
}

export const MODAL_MESSAGES = {
  SAVE_CONFIRM_TITLE: 'Guardar cambios de Perfil',
  SAVE_CONFIRM_MESSAGE:
    'Revisá que la información ingresada sea correcta. Si guardás los cambios, se actualizarán los datos de tu perfil.',
  DISCARD_TITLE: 'Descartar cambios en el perfil',
  DISCARD_MESSAGE:
    'Si los descartás, se perderán los cambios realizados y se mantendrá la información anterior de tu perfil.',
}

export const TOAST_MESSAGES = {
  SUCCESS: 'Los datos de tu perfil se guardaron exitosamente',
  ERROR: 'Ocurrió un error al guardar los datos de tu perfil. Intentá nuevamente más tarde.',
  ASOCIAR_CUENTA_SUCCESS: 'La solicitud de asociación fue enviada. Quedará pendiente de aprobación del Administrador.',
  // Escenario 2: error de negocio devuelto por el backend (ej. solicitud pendiente duplicada)
  ASOCIAR_CUENTA_ERROR_NEGOCIO: 'Esta CUIT ya se encuentra asociada a tu usuario.',
  // Escenario 2a: el CUIT ingresado no corresponde a un cliente de Provincia ART
  ASOCIAR_CUENTA_ERROR_CUIT_NO_CLIENTE: 'La CUIT ingresada no es cliente de Provincia ART.',
  // Escenario 3: error sin mensaje del backend (fallback, ej. error interno del servidor)
  ASOCIAR_CUENTA_ERROR: 'Error interno del servidor. Intentá nuevamente más tarde.',
  // Escenario 4: excepción de red / timeout
  ASOCIAR_CUENTA_ERROR_RED:
    'No pudimos conectarnos con el servidor. Revisá tu conexión e intentá nuevamente más tarde.',
  // Textos que devuelve el backend, para mapear errores de negocio conocidos
  BACKEND_MESSAGES: {
    CUIT_NO_CLIENTE: 'La CUIT ingresada no es cliente de Provincia ART',
  },
}
